import styled from 'styled-components';

const HorizontalSpacer = styled.div`
  width: ${props => props.width};
`;

export default HorizontalSpacer;
